function ModalContainer({ children }) {
    return (
        <div className='fixed z-20 left-0 top-0 w-screen h-screen bg-[#00000080] flex items-center justify-center'>
            {children}
        </div>
    );
}

export default ModalContainer;
